import { Switch } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

import { spacingV2 } from '~/src/dash/components/layout/common';
import { borderRadius, Col, Cols, Row, Rows, Text, TextInput } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { useBaseStore } from '~/src/dash/views/base/contexts';

export const OverviewSection = () => {
  const { user } = useBaseStore();

  return (
    <Rows>
      <Row>
        <Cols gap={spacingV2.medium}>
          <Col width='1rem' paddingTop='0.3rem'>
            <img src={'/assets/shared/svg/Cube.svg'} />
          </Col>
          <Col>
            <Text sizeV2 bold large>
              Overview
            </Text>
          </Col>
        </Cols>
      </Row>

      <Row noVerticalPadding>
        <Cols wrap gap={spacingV2.large}>
          <Col>
            <Cols marginBottom={spacingV2.base} style={{ alignItems: 'center' }}>
              <Col width='7.5rem'>
                <Text sizeV2 small bold>
                  Report Name
                </Text>
              </Col>
              <Col>
                <TextInput
                  width='28.75rem'
                  inputSize='small'
                  placeholder='Report Name'
                  handleOnChange={() => null}
                />
              </Col>
            </Cols>

            <Cols marginBottom={spacingV2.base} style={{ alignItems: 'center' }}>
              <Col width='7.5rem'>
                <Text sizeV2 small bold>
                  Permission *
                </Text>
              </Col>
              <Col>
                <Switch name='SuperUserOnly' value={true} onChange={() => null}></Switch>
              </Col>
              <Col>
                <Text sizeV2 small>
                  Restricted To Super Admin
                </Text>
              </Col>
            </Cols>
          </Col>

          <Col
            style={{
              background: `${publicaColors.veryLightGray}`,
              borderRadius: borderRadius.small,
            }}
          >
            <Cols>
              <Col>
                <Rows extraSmallPaddingV2>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 bold small>
                      Created By
                    </Text>
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 bold small>
                      Last Modified
                    </Text>
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 bold small>
                      Last Ran
                    </Text>
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Row
                      style={{
                        borderRadius: borderRadius.small,
                        backgroundColor: publicaColors.lightGray,
                        padding: '0.125rem',
                      }}
                    >
                      <Text sizeV2 bold small>
                        Unscheduled
                        {/* TODO: change to scheduled and change styling of inner row for schedule report */}
                      </Text>
                    </Row>
                  </Row>
                </Rows>
              </Col>

              <Col>
                <Rows extraSmallPaddingV2>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 small>
                      {user.user.Username}
                    </Text>
                    {/* TODO: load in created by user for existing report */}
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 small>
                      {user.user.Username}
                    </Text>
                    {/* TODO: load in modified by user for existing report */}
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 small>
                      N/A
                    </Text>
                    {/* TODO: load in last ran date for existing report */}
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 small>
                      Set up schedule below
                    </Text>
                    {/* TODO: load in scheduled rune date for existing report */}
                  </Row>
                </Rows>
              </Col>

              <Col>
                <Rows extraSmallPaddingV2>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 small>
                      {moment().format('MM-DD-YYYY HH:MM')}
                    </Text>
                    {/* TODO: load in created at date/time for existing report */}
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 small>
                      {moment().format('MM-DD-YYYY HH:MM')}
                    </Text>
                    {/* TODO: load in last modified date/time for existing report */}
                  </Row>
                  <Row extraSmallVerticalPaddingV2>
                    <Text sizeV2 small>
                      N/A - N/A
                    </Text>
                    {/* TODO: load in last ran start and end dates for existing report */}
                  </Row>
                </Rows>
              </Col>
            </Cols>
          </Col>
        </Cols>
      </Row>
    </Rows>
  );
};
